// extracted by mini-css-extract-plugin
module.exports = {"container":"Search_container__2PjIb","form":"Search_form__2rAOb"};